import { render } from "./FooterApp.vue?vue&type=template&id=46dfa65e&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"

import "@/assets/css/Footer.css?vue&type=style&index=0&id=46dfa65e&scoped=true&lang=css&external"
import "./FooterApp.vue?vue&type=style&index=1&id=46dfa65e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46dfa65e"]])

export default __exports__